<template>
      <TheFooter class="bg-dark">
        <div >
          <footer id="footer">

  </footer> <!--footer-->
          <div>  <a href="https://pttbs.com"></a>
          <span class="ml-1">&copy; 2019 PT Tirta Bumi Sentosa.</span>
      </div>   
      <div>
    <span class="ml-1">Menara Batavia Lt.8 Jl. K.H Mas Masyur Jakarta Pusat 10220 Indonesia</span>
    </div> 
      <div>
    <span class="ml-1">Phone : +62 21 2251 3771, +62 21 25982770   Fax : +62 21 25982035</span>
    </div> 
       <div>
    <span class="ml-1">Email : sales@pttbs.com</span>
    </div> 
   
       <br>
       </div>
        <br>
   <div class="ml-auto">
          <span class="mr-1">Powered by</span>
          <a href="https://coreui.io">CoreUI for Vue</a>
        </div>
         
       
      </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  },
}
</script>
